export enum BondApiUrls {
  Bonds = "/v1/Bonds",
}
